<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>
<style lang="scss" >

  .custom_date_class {
    span {
      background: #ea6151;
      color: red;
      border-radius: 50%;
      color: #fff !important;
      &:hover {
        background-color: #409eff;
      }
    }
    &::after {
      content: "已标记";
      display: inline-block;
      position: absolute;
      width: 100%;
      font-size: 12px;
      color: red;
      bottom: -15px;
      left: 0;
      text-align: center;
      white-space: nowrap;
    }
  }
  .custom_date_class_a{
    span {
      background: #a9ea3f;
      color: #37ff27;
      border-radius: 50%;
      color: #fff !important;
      &:hover {
        background-color: #409eff;
      }
    }
    &::after {
      content: "未标记";
      display: inline-block;
      position: absolute;
      width: 100%;
      font-size: 12px;
      color: #3aff44;
      bottom: -15px;
      left: 0;
      text-align: center;
      white-space: nowrap;
    }
  }
  .el-date-picker-custom {
    .el-date-table td {
      padding: 10px 0;
    }
  }
  body .el-table th.gutter{
    display: table-cell!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue